import { Injectable } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Observable, Subject } from 'rxjs';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root'
})
export class TravelService {
  currentPage: any = '';
  CurrentTab: any = '';
  constructor(private crudService: CrudService) {

  }

  getTravelDetailsByRecordID(RecordNo: string): Observable<any> {
    return this.crudService.get<any>('Travel/GetTravelDetailsById?Id=' + RecordNo);
  }

  DeleteTravelLine(TravelID: any, UserId: string): Observable<any> {
    return this.crudService.get('Travel/DeleteTravelLineById?Id=' + TravelID + '&UserId=' + UserId);
  }

  DeleteTravelById(RecordId: any, UserId: string): Observable<any> {
    return this.crudService.get('Travel/DeleteTravelById?Id=' + RecordId + '&UserId=' + UserId);
  }
  SaveTravel(TravelData: any): Observable<any> {
    return this.crudService.post<any>('Travel/SaveTravelDetails', TravelData);
  }

  getTravelList(UserId: string): Observable<any> {
    return this.crudService.get<any>('Travel/GetAllTravelDetails?UserId=' + UserId);
  }

  getAuditHistory(DocumentNo: string): Observable<any> {
    return this.crudService.get<any>('Travel/GetAuditHistory?DocumentNo=' + DocumentNo);
  }

  getFYearMaster(): Observable<any> {
    return this.crudService.get<any>('Travel/GetFYearMaster');
  }

  GetReportingHeadApprovalDetails(UserId: string, STATUS: any = '', companyname: any = '', empType: any = ''): Observable<any> {
    // return this.crudService.get<any>('Travel/GetReportingHeadApprovalDetails?UserId=' + UserId);
    return this.crudService.get<any>(
      `Travel/GetReportingHeadApprovalDetails?UserId=` + UserId +
      `&pgNo=1&maxRows=500&status=` + STATUS +
      `&companyname=` + companyname +
      `&empType=` + empType
    );
  }
  GetRSMApprovalDetails(UserId: string, STATUS: any = '', companyname: any = '', empType: any = ''): Observable<any> {
    // return this.crudService.get<any>('Travel/GetReportingHeadApprovalDetails?UserId=' + UserId);
    return this.crudService.get<any>(`Travel/GetRSMApprovalDetails?UserId=` + UserId + `&pgNo=1&maxRows=500&status=` + STATUS + `&companyname=` + companyname + `&empType=` + empType)
  }
  GetGDHApprovalDetails(UserId: string, STATUS: any = '', companyname: any = '', empType: any = ''): Observable<any> {
    // return this.crudService.get<any>('Travel/GetReportingHeadApprovalDetails?UserId=' + UserId);
    return this.crudService.get<any>(`Travel/GetGDHApprovalDetails?UserId=` + UserId + `&pgNo=1&maxRows=500&status=` + STATUS + `&companyname=` + companyname + `&empType=` + empType)
  }



  GetFinanceApprovalDetails(UserId: string): Observable<any> {
    return this.crudService.get<any>('Travel/GetFinanceApprovalDetails?UserId=' + UserId);
  }


  UpdateStatus(TravelData: any): Observable<any> {
    return this.crudService.post<any>('Travel/UpdateStatus', TravelData);
  }
  BulkApprove(data: any): Observable<any> {
    return this.crudService.post<any>('Travel/BulkApprove', data);
  }
  BulkReject(data: any): Observable<any> {
    return this.crudService.post<any>(
      'Travel/BulkReject',
      data
    );
  }
  ReInitiateTravel(TravelData: any): Observable<any> {
    return this.crudService.post<any>('Travel/ReInitiateTravel', TravelData);
  }

  SaveFYearMaster(TravelData: any): Observable<any> {
    return this.crudService.post<any>('Travel/SaveFYearMaster', TravelData);
  }

  DeleteFYearMaster(TravelID: any, UserId: string): Observable<any> {
    return this.crudService.get('Travel/DeleteFYearMaster?Id=' + TravelID + '&UserId=' + UserId);
  }

  getRsmMaster(): Observable<any> {
    return this.crudService.get<any>('Travel/GetRsmMaster');
  }

  SaveRsmMaster(data: any): Observable<any> {
    return this.crudService.post<any>('Travel/SaveRsmMaster', data);
  }

  DeleteRsmMaster(Id: any, UserId: string): Observable<any> {
    return this.crudService.get('Travel/DeleteRsmMaster?Id=' + Id + '&UserId=' + UserId);
  }

  BulkSaveRsmMaster(list: any[]): Observable<any> {
    return this.crudService.post<any>('Travel/BulkSaveRsmMaster', list);
  }
  getTravelERPReport(empType: string): Observable<any> {
    return this.crudService.get(`Travel/TravelERPReport?empType=${empType}`);
  }
  // getTravelSummaryReport(): Observable<any> {
  //   return this.crudService.get('Travel/TravelSummaryReport');
  // }
  getTravelSummaryReport(empType: string, tmc: string = '', status: string = '', sbuCode: string = '', fromDate: string = '', toDate: string = ''): Observable<any> {
    let url = `Travel/TravelSummaryReport?empType=${empType}`;
    if (tmc) {
      url += `&TMC=${tmc}`;
    }
    if (status) {
      url += `&STATUS=${status}`;
    }
    if (sbuCode) {
      url += `&SBU_CODE=${sbuCode}`;
    }
    if (fromDate) {
      url += `&fromDate=${encodeURIComponent(fromDate)}`;
    }
    if (toDate) {
      url += `&toDate=${encodeURIComponent(toDate)}`;
    }
    return this.crudService.get(url);
  }

  getALLBu(): Observable<any> {
    return this.crudService.get('Travel/GetAllBUDetails');
  }

  getTravelERPReportKockpit(): Observable<any> {
    return this.crudService.get('Travel/TravelERPReportKockpit');
  }
  getTravelSummaryReportKockpit(): Observable<any> {
    return this.crudService.get('Travel/TravelSummaryReportkockpit');
  }

  UpdateFyMaster(TravelData: any): Observable<any> {
    return this.crudService.post<any>('Travel/UpdateFyMaster', TravelData);
  }

  UpdatelistStatus(TravelData: any): Observable<any> {
    return this.crudService.post<any>('Travel/UpdateListStatus', TravelData);
  }

  getGuestHouseFeedbackReport(reqId: string = ''): Observable<any> {
    let url = 'TravelModule/GetFeedbackAllDetails';

    if (reqId) {
      url += '?ReqId=' + reqId;
    }

    return this.crudService.get<any>(url);
  }

  //setPageNo(pageNo:any,tab :any){
  //this.currentPage=pageNo;
  //this.CurrentTab=tab;
  //}
  //getPageNo(){
  //return {"curentPage":this.currentPage,
  //  "currentTab":this.CurrentTab
  //}
  //}
}